var map = {
	"./Amazing-24.png": "1N/b",
	"./Blessed-24.png": "SOoa",
	"./Cold-24.png": "oe6h",
	"./Confident-24.png": "AlUG",
	"./Cool-24.png": "s0ul",
	"./Crazy-24.png": "WzRM",
	"./Festive-24.png": "/euA",
	"./Injured-24.png": "1hDP",
	"./Loved-24.png": "xxpr",
	"./Scared-24.png": "0z0z",
	"./Sick-24.png": "KlCV",
	"./Speachless-24.png": "khta",
	"./Tired-24.png": "sELS",
	"./angry-40.png": "7M+g",
	"./bad-32.png": "XCcF",
	"./briefcase-18.png": "+3Gp",
	"./briefcase-72.png": "eYET",
	"./calendar-18.png": "iABw",
	"./calendar-72.png": "BvX9",
	"./confetti-24.png": "qStk",
	"./embrace-40.png": "Uj5s",
	"./emotional-40.png": "fuKe",
	"./good-32.png": "lsTC",
	"./happy-40.png": "N/At",
	"./happy-80.png": "Hl1/",
	"./hot-24.png": "VI6m",
	"./inlove-24.png": "IHgN",
	"./like-40.png": "j3ox",
	"./newspaper-18.png": "Bppp",
	"./newspaper-72.png": "Mg4a",
	"./okay-32.png": "oWss",
	"./very bad-32.png": "dN3Y",
	"./very good-32.png": "Ti5Q"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YBT7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emojis ^\.\/.*\.png$
// module id = YBT7
// module chunks = 1